module.exports = __webpack_public_path__ + "img/fbs_image.abd38f71.jpg";